import React, { useRef } from "react";
import { Select as Origin, SelectProps } from "antd";
import { SearchContext } from "./context";
import classNames from "classnames";

const BaseSelect: React.FC<SelectProps<any>> = (props) => {
    const { onPressEnter = () => {} } = React.useContext(SearchContext) || {};

    const visible = useRef(true);

    const hasValue = props.value;

    return (
        <Origin
            popupMatchSelectWidth={false}
            style={{ fontSize: 13, width: 110 }}
            {...props}
            className={classNames(
                {
                    "has-value": hasValue,
                },
                props.className,
            )}
            size="small"
            onKeyDown={(evt) => {
                try {
                    props?.onKeyDown?.(evt);
                } catch (error) {}

                if ((evt.code === "NumpadEnter" || evt.code === "Enter") && !visible.current) {
                    onPressEnter();
                }
            }}
            onOpenChange={(v) => {
                visible.current = v;

                props?.onOpenChange?.(v);
            }}
        />
    );
};

export const Select = React.memo(BaseSelect);
